import clsx from 'clsx';
import type { ReactNode } from 'react';

type FieldProps = {
  label?: string;
  hint?: string;
  error?: string;
  kicker?: string;
  children: ReactNode;
  className?: string;
};

export function Field({ label, hint, error, kicker, children, className }: FieldProps) {
  return (
    <label className={clsx('block', className)}>
      {kicker && <div className="kicker mb-1.5">{kicker}</div>}
      {label && <div className="text-[12px] text-zinc-400 mb-1.5 font-medium">{label}</div>}
      {children}
      {hint && !error && <div className="text-[11.5px] text-zinc-500 mt-1.5">{hint}</div>}
      {error && <div className="text-[11.5px] text-rose-400 mt-1.5">{error}</div>}
    </label>
  );
}
